import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { getMediaUrl } from '../services/api';
import './Departments.css';

const Departments = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDepartments();
  }, []);

  const loadDepartments = async () => {
    try {
      const response = await api.get('/departments/');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error loading departments:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </Container>
    );
  }

  return (
    <Container className="departments-page py-5">
      <h1 className="page-title mb-5">Our Departments</h1>
      <Row>
        {departments.map(dept => (
          <Col key={dept.id} md={4} className="mb-4">
            <Card className="department-card h-100">
              {dept.image && (
                <Card.Img 
                  variant="top" 
                  src={getMediaUrl(dept.image)} 
                  alt={dept.name}
                />
              )}
              <Card.Body>
                <Card.Title>
                  <Link to={`/departments/${dept.slug}`}>{dept.name}</Link>
                </Card.Title>
                <Card.Text>
                  <strong>Head:</strong> {dept.head_officer}
                </Card.Text>
                <Card.Text>
                  <strong>Contact:</strong> {dept.contact_phone}
                </Card.Text>
                <Link to={`/departments/${dept.slug}`} className="btn btn-primary btn-sm">
                  View Details
                </Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Departments;
